/**
 * @desc batchBind
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierBatchSnBindRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierSn/batchBind`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
